/**
 * Money is always stored/transmitted as an integer minor unit (paise for
 * INR) to avoid floating point drift. These helpers convert at the edges.
 */
export function formatCurrency(
  amountInMinorUnits: number,
  currency: 'INR' | 'USD' = 'INR',
  locale = 'en-IN',
): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(amountInMinorUnits / 100);
}

export function toMinorUnits(amount: number): number {
  return Math.round(amount * 100);
}

export function toMajorUnits(amountInMinorUnits: number): number {
  return amountInMinorUnits / 100;
}
